import { Route } from 'react-router-dom';

import { RecommendationRevealPage } from './RecommendationRevealPage.js';

/** A configured line's own direction reveal and activation. */
export function recommendationsRoutes() {
  return (
    <Route
      path="/production-lines/:productionLineId/activate"
      element={<RecommendationRevealPage />}
    />
  );
}
